'use client';

import { useRouter, useSearchParams } from 'next/navigation';

const OPTIONS = [
  { v: 'brand', label: 'Brand' },
  { v: 'oem', label: 'OEM SKU' },
  { v: 'stock-desc', label: 'Stock: high → low' },
  { v: 'stock-asc', label: 'Stock: low → high' },
];

export function SortDropdown() {
  const router = useRouter();
  const sp = useSearchParams();
  const current = sp.get('sort') ?? 'brand';

  function onChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const params = new URLSearchParams(sp.toString());
    params.set('sort', e.target.value);
    params.delete('offset');
    router.push(`?${params.toString()}`);
  }

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-neutral-600">Sort:</span>
      <select
        value={current}
        onChange={onChange}
        className="rounded border border-neutral-300 bg-white px-2 py-1"
      >
        {OPTIONS.map((o) => (
          <option key={o.v} value={o.v}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
